(function ($) {
  Drupal.behaviors.ehArticleImageCarousel = {
    attach: function (context, settings) {
      var articleImageFlexSlider = $('.article-image-flexslider', context);

      articleImageFlexSlider.each(function () {
        var thisArticleImageFlexSlider = $(this);
        var imageContainer = thisArticleImageFlexSlider.find('.imageContainer'),
	  slides = thisArticleImageFlexSlider.find('.slides'),
	  totalSlideCount = imageContainer.length;

        if (imageContainer.length > 0) {
          // Add a clone slide at the top
          slides.prepend("<li class='prependClone'></li>");
          nodeClone = imageContainer[totalSlideCount - 1].cloneNode(true);
          slides.find('.prependClone').append(nodeClone);

          // Initiate Slider
          var imgItemWidth = 562; // img width + margin right

          if ($(window).width() < 767) {
            imgItemWidth = 333; // iphone portrait device half width
          }
          if ($(window).width() >= 1150) {
            imgItemWidth = 650; // MAC device
          }

          slides.find('.eh_hero_article_images_content').each(function (index, el) {
            var thisEle = $(this);

            thisEle.css({
              'max-width': thisEle.width(),
              // 'max-height': thisEle.height(),
              'height': 'auto',
              'width': 'auto'
	  });
	  if (index == 1) {
	    // Once the first image is loaded then vertically center align the nav arrows 
              thisEle.find('.sliderImage').on('load', function() {
                alignSliderNavArrows(thisArticleImageFlexSlider);
              });
            }
          });

          thisArticleImageFlexSlider.flexslider({
	  animation: 'slide', // Sets animation effect to "fade/slide"
	  slideshow: false,
	  reverse: false,
	  animationLoop: true, // Sets the infinite loop
	  itemWidth: imgItemWidth,
	  itemMargin: 0,
	  animationSpeed: 1100,
	  minItems: 2,
	  move: 1,
	  start: function (slider) {
	    var totalWidth = (slider.find('.slides .prependClone').width() * 1.5) + parseInt(slides.find('.prependClone').css('margin-right')) * 1;

	    slider.find('.slides').css('left', ($(window).width() / 2 - totalWidth) + 'px');
              alignSliderNavArrows(slider);
              var cloneStyle = slider.find('.slides .prependClone').attr('style');

              slider.find('.slides .appendClone').attr('style', cloneStyle);
	  },
	  before: function (slider) {
	    var totalWidth = (slider.find('.slides .prependClone').width() * 1.5) + parseInt(slides.find('.prependClone').css('margin-right')) * 1;

              // slider.find('.slides').css('left', ($(window).width()/2 - totalWidth) + 'px');
              alignSliderNavArrows(slider);
	  },
	  after: function () {
	    var slideNumber = thisArticleImageFlexSlider.find('.flex-active').html();

	    thisArticleImageFlexSlider.find('.flex-control-nav.flex-control-paging .pagination').html(slideNumber + '/' + navigationLinkCount);
	  }
          });
          // Displays the navigational links count

          var navigationLinkCount = thisArticleImageFlexSlider.find('.flex-control-nav li').length;
          var slideNumber = thisArticleImageFlexSlider.find('.flex-active').html();

          thisArticleImageFlexSlider.find('.flex-control-nav.flex-control-paging').append("<div class='pagination'>" + slideNumber + '/' + navigationLinkCount + '</div>');

          // Add a clone slide at the bottom
          slides.append("<li class='appendClone'></li>");
          nodeClone = imageContainer[0].cloneNode(true);
          slides.find('.appendClone').append(nodeClone);

          // Initiate Navigational arrow click event
          thisArticleImageFlexSlider
	  .on('click', '.flex-direction-nav .flex-next, .flex-direction-nav .flex-prev', function () {
	    slideNumber = parseInt(thisArticleImageFlexSlider.find('.flex-active').html());
              thisArticleImageFlexSlider.find('.flex-control-nav.flex-control-paging .pagination').html(slideNumber + '/' + navigationLinkCount);
	    thisArticleImageFlexSlider.find('.share').hide();
	    thisArticleImageFlexSlider.find('.share_link').show();
	    var leftVal = slides.find('.prependClone').width() + parseInt(slides.find('.prependClone').css('margin-right'));

	    leftVal *= (slideNumber - 1) * -1;

	    var totalWidth = (thisArticleImageFlexSlider.find('.slides .prependClone').width() * 1.5) + parseInt(slides.find('.prependClone').css('margin-right')) * 1;
              var defaultLeftVal = $(window).width() / 2 - totalWidth;

              if (browserTransitionSupport()) {
                slides.css({ 'transform': 'translate3d(' + leftVal + 'px, 0px, 0px)' });
	    } else {
	      slides.animate({
                  'left': defaultLeftVal + parseInt(leftVal) + 'px'
                }, 600);
              }
	  });
        }
      });

      var articleImgCarouselResizeTimer = null;

      $(window).resize(function () {
        // debounced - Execute the functionality only once when the resize stops
        if (articleImgCarouselResizeTimer) {
          clearTimeout(articleImgCarouselResizeTimer);
        }
        // Only the last instant of the resize triggers
        articleImgCarouselResizeTimer = setTimeout(function () {
          articleImageFlexSlider.each(function () {
            var sliderObj = $(this),
              slides = sliderObj.find('.slides'),
              prependedClone = null;

            alignSliderNavArrows(sliderObj);
            var cloneStyle = sliderObj.find('.slides .prependClone').attr('style');

            sliderObj.find('.slides .appendClone').attr('style', cloneStyle);
            prependedClone = slides.find('.prependClone');
            var totalWidth = (prependedClone.width() * 1.5) + parseInt(prependedClone.css('margin-right')) * 1;

            slides.css('left', ($(window).width() / 2 - totalWidth) + 'px');
          });
          // On window focus the slider recalculates
          $(window).focus();
        }, 100);
      });

      function alignSliderNavArrows(sliderObj) {
        // Take first image for reference to align the arrows vertically middle
        var sliderImg = sliderObj.find('.eh_hero_article_images:eq(1)');

        // If first image is broken then lets take the last image's height
        if (sliderImg.find('.sliderImage').height() < 50) {
          sliderImg = sliderObj.find('.eh_hero_article_images');
        }
        var sliderNav = sliderObj.find('.flex-prev');
        var navTop = (sliderImg.find('.sliderImage').height() / 2) + parseInt(sliderImg.css('padding-top')) - sliderNav.height() / 2;

        sliderObj.find('.flex-direction-nav a').attr('style', 'top: ' + navTop + 'px !important');
      }

      function browserTransitionSupport() {
        var obj = document.createElement('div'),
          props = ['perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];

        for (var i in props) {
          if (obj.style[props[i]] !== undefined) {
            return true;
          }
        }

        return false;
      }
    }
  };
})(jQuery);
